export default __webpack_public_path__ + "1906119496b2824f0ae8fb527875f833.png";